module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendars-bulk text-dark"
  }, [_c('div', {
    staticClass: "sub-header no-print"
  }, [_c('p', {
    staticClass: "sub-header__item sub-header__title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')) + "\n      "), _c('span', {
    staticClass: "sub-header__title-divider icon-arrow-right4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "sub-header__item",
    class: {
      'sub-header__item--active': _vm.selectedView === 'crudCalendars'
    },
    on: {
      "click": function($event) {
        _vm.selectedView = 'crudCalendars'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.edit_calendars')))]), _vm._v(" "), _c('p', {
    staticClass: "sub-header__item",
    class: {
      'sub-header__item--active': _vm.selectedView === 'copyCalendars'
    },
    on: {
      "click": function($event) {
        _vm.selectedView = 'copyCalendars'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.copy_calendars')) + "\n    ")]), _vm._v(" "), (_vm.userHasPermissionToEditOthersPresence) ? _c('p', {
    staticClass: "sub-header__item",
    class: {
      'sub-header__item--active': _vm.selectedView === 'presence'
    },
    on: {
      "click": function($event) {
        _vm.selectedView = 'presence'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.add_presence')) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sub-header__item",
    class: {
      'sub-header__item--active': _vm.selectedView === 'deleteDays'
    },
    on: {
      "click": function($event) {
        _vm.selectedView = 'deleteDays'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.calendars.delete_events_in_date_range')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-pad min-height"
  }, [_c('div', {
    staticClass: "calendars-bulk__header"
  }, [_c('div', {
    staticClass: "calendars-bulk__header__left"
  }, [_c('h1', {
    staticClass: "marg-20-right text-dark"
  }, [_vm._v(_vm._s(_vm.$t('vue2.calendars.calendars')))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "calendars-bulk__header__right"
  }, [(_vm.selectedView === 'deleteDays') ? _c('Datepickerrange', {
    attrs: {
      "allow-same-date": true,
      "startdate": _vm.fromDate,
      "enddate": _vm.toDate
    },
    on: {
      "startchanged": _vm.setFromDate,
      "endchanged": _vm.setToDate
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedView === 'crudCalendars') ? [_c('CalendarsBulkArchiveCalendar', {
    attrs: {
      "calendars": _vm.klassCalendars,
      "calType": "klass",
      "isOpen": true
    }
  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
    attrs: {
      "calendars": _vm.roomCalendarsInclArchived,
      "calType": "room"
    }
  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
    attrs: {
      "calendars": _vm.mergeCalendarsInclArchived,
      "calType": "merge"
    }
  }), _vm._v(" "), _c('CalendarsBulkArchiveCalendar', {
    attrs: {
      "calendars": _vm.otherCalendars,
      "calType": "other"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'copyCalendars') ? [_c('CopyMultipleCalendars', {
    attrs: {
      "calendars": _vm.klassCalendars,
      "calType": "klass",
      "isOpen": true
    }
  }), _vm._v(" "), _c('CopyMultipleCalendars', {
    attrs: {
      "calendars": _vm.userCalendars,
      "calType": "user"
    }
  }), _vm._v(" "), _c('CopyMultipleCalendars', {
    attrs: {
      "calendars": _vm.roomCalendarsInclArchived,
      "calType": "room"
    }
  }), _vm._v(" "), _c('CopyMultipleCalendars', {
    attrs: {
      "calendars": _vm.mergeCalendarsInclArchived,
      "calType": "merge"
    }
  }), _vm._v(" "), _c('CopyMultipleCalendars', {
    attrs: {
      "calendars": _vm.otherCalendars,
      "calType": "other"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'presence') ? [_c('PresenceForUsers')] : _vm._e(), _vm._v(" "), (_vm.selectedView === 'deleteDays') ? [(_vm.klassCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
    attrs: {
      "fromDate": _vm.fromDate,
      "toDate": _vm.toDate,
      "calendars": _vm.klassCalendars,
      "calType": "klass",
      "isOpen": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.kindergartenCalendars.length > 0) ? _c('CalendarsDeleteEventsInDays', {
    attrs: {
      "fromDate": _vm.fromDate,
      "toDate": _vm.toDate,
      "calendars": _vm.kindergartenCalendars,
      "calType": "Stuer",
      "isOpen": true
    }
  }) : _vm._e(), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
    attrs: {
      "fromDate": _vm.fromDate,
      "toDate": _vm.toDate,
      "calendars": _vm.userCalendars,
      "calType": "user",
      "isOpen": false
    }
  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
    attrs: {
      "fromDate": _vm.fromDate,
      "toDate": _vm.toDate,
      "calendars": _vm.roomCalendarsInclArchived,
      "calType": "room",
      "isOpen": false
    }
  }), _vm._v(" "), _c('CalendarsDeleteEventsInDays', {
    attrs: {
      "fromDate": _vm.fromDate,
      "toDate": _vm.toDate,
      "calendars": _vm.otherCalendars,
      "calType": "other",
      "isOpen": false
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d99ac434!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarsBulk.vue
// module id = 2136
// module chunks = 1